import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

const STAGGER_MS = 40;
const STAGGER_CAP_MS = 600;

/** Marks grow from zero on mount: `grown` flips true on the next frame so CSS
 *  transitions run; `delay(i)` staggers the i-th mark. Reduced motion → no
 *  transition at all (grown is true immediately, delay is "0ms"). */
export function useGrowIn() {
  const reduced = usePrefersReducedMotion();
  const [grown, setGrown] = useState(reduced);
  useEffect(() => {
    if (reduced) {
      setGrown(true);
      return;
    }
    const raf = window.requestAnimationFrame(() => setGrown(true));
    return () => window.cancelAnimationFrame(raf);
  }, [reduced]);
  const delay = (i: number) =>
    reduced ? "0ms" : `${Math.min(i * STAGGER_MS, STAGGER_CAP_MS)}ms`;
  return { grown, reduced, delay };
}
